import React, { useCallback, useMemo, useState, } from 'react';
import styled from 'styled-components';
import { MinimizeFAB } from './MinimizeFAB';
import { ChatBoxHeader } from './ChatBoxHeader';
import { cssColorValue, semanticBackgroundColors, semanticColors, } from '@spotify-internal/encore-web';
const PositionContainer = styled.div `
  position: fixed;
  width: 26rem;
  z-index: 9999;
  transform: translate3d(0, 0, 0);
  height: 44rem;
  min-height: 10rem;
  max-height: calc(min(95vh, 100vh - var(--pt-chatbox-bottom)));
  bottom: var(--pt-chatbox-bottom);
  right: var(--pt-chatbox-right);

  @media screen and (max-width: 768px) {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: unset;
    height: unset;
    max-height: unset;
  }
`;
const ChatboxGrid = styled.div `
  display: grid;
  grid-template-rows: 5.5rem 1fr 4rem;
  overflow: hidden;
  height: 100%;
  background: #fff;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.2);
  border-radius: 0.5rem;

  @media screen and (max-width: 768px) {
    border-radius: unset;
  }
`;
export const ChatboxFrame = ({ children, onMinimizeChange, notificationCount, onCloseClick, }) => {
    const [minimized, setMinimized] = useState(false);
    const setMinimizedCb = useCallback((isMinimized) => {
        setMinimized(isMinimized);
        if (minimized !== isMinimized)
            onMinimizeChange(isMinimized);
    }, [minimized, onMinimizeChange]);
    const backgroundColor = useMemo(() => cssColorValue(semanticBackgroundColors.backgroundBase), []);
    const foregroundColor = useMemo(() => cssColorValue(semanticColors.textBase), []);
    return (React.createElement(React.Fragment, null,
        React.createElement(PositionContainer, { style: { display: minimized ? 'none' : 'block' } },
            React.createElement(ChatboxGrid, null,
                React.createElement(ChatBoxHeader, { notifications: notificationCount, onClose: onCloseClick, onMinimizeClicked: () => setMinimizedCb(true), backgroundColor: backgroundColor, foregroundColor: foregroundColor }),
                children)),
        React.createElement(MinimizeFAB, { minimized: minimized, notifications: notificationCount, onClick: () => setMinimizedCb(!minimized), backgroundColor: backgroundColor, foregroundColor: foregroundColor })));
};
